
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `Tippen Sie auf „Im Browser öffnen…“`,
's182ab2d6c997515f': `Fügen Sie es zu Ihrem Startbildschirm hinzu, um eine umfassende Erfahrung und einen leichten Zugriff zu erhalten.`,
's224cbcec014ef6b5': `Drücken Sie auf Teilen in der Navigationsleiste`,
's233af3b7eb5e0364': `Zur Startseite hinzufügen`,
's37a9e8aec5713460': `Mehr`,
's4c3161035f3a1413': `Drücken Sie auf Menü`,
's4e1e10a6ca408245': `Tippen Sie auf "Zum Startbildschirm hinzufügen"`,
's6196153c4b0c1ea0': `Installieren`,
's633502f7cff4f847': `Öffnen Sie das Menü Ihres Browsers`,
's681e399d63311fba': `Galerie anzeigen`,
's6d14a4f70ba4e3cf': `Drücken Sie auf Menü, wenn kein Teilen-Symbol vorhanden ist`,
's922329d6f6213590': `Zum Dock hinzufügen`,
's9c63a79ffcc2a3a3': `Drücken Sie auf "Zum Startbildschirm hinzufügen"`,
'sa2d71bfd9525168d': `Drücken Sie auf "Zum Dock hinzufügen"`,
'sa5ef80b4bb9b39f8': `Weniger`,
'sb527eca1c1d7e7be': `Öffnen Sie das Menü des In-App-Browsers`,
'sba52286c21552a4e': `Installieren Sie es auf Ihrem Gerät für eine umfassende Erfahrung und einen leichten Zugriff.`,
'sc16e00a7a8b2fde2': `Zurück`,
'scdaf4bbff76674c8': `Hinzufügen zum Startbildschirm`,
'sd18a5b85f599ff3c': `Kopierten Link in Safari öffnen`,
'se72fc3a84f9b51c3': `Zum Kopieren des Links tippen`,
'se740f75b95a51807': `Fügen Sie es zu Ihrem Dock hinzu, um eine umfassende Erfahrung und einen leichten Zugriff zu erhalten.`,
'sfa6c42cdf48d93d2': `Dieser Browser unterstützt diese Funktion jedoch nicht. Öffnen Sie den Link in einem externen Browser, um fortzufahren.`,
'sfb78526365796a41': `Drücken Sie auf "Mehr anzeigen" im Teilen-Menü`,
'sfea652f6580ff086': `Diese Website verfügt über App-Funktionalität.`,
    };
  